<template>
  <div class="flex flex-col">
    <div v-for="contact in contacts" :key="contact.name">
      <div class="grid grid-cols-4 gap-2">
        <span class="font-bold m-2 pl-2">
          {{ contact.name }}
        </span>
        <div class="m-2">
          <span class="mr-2"> Relationship: </span>
          {{ contact.relationship }}
        </div>
        <div class="m-2">
          <span class="mr-2"> Phone Number: </span>
          {{ contact.phone }}
        </div>
        <div class="m-2" v-if="contact.email">
          <span class="mr-2"> Email: </span>
          {{ contact.email }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    contacts: [],
  },
}
</script>
